import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { StrapiSampleInformationCreateData } from '../../api/strapiCrm';
import { strapiCreateSampleInformation } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useCreateSampleInformationMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: StrapiSampleInformationCreateData) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiCreateSampleInformation(jwt, data);
    },
    onSuccess: async (_, data) => {
      const qid = data.quotation.connect[0];
      await qc.invalidateQueries({ queryKey: queryKeys.sampleInformationsFlat(jwt) });
      await qc.invalidateQueries({ queryKey: queryKeys.quotationDetail(jwt, qid) });
      await qc.invalidateQueries({ queryKey: queryKeys.quotationsListPrefix(jwt) });
      await qc.invalidateQueries({ queryKey: queryKeys.workOrdersListPrefix(jwt) });
      await qc.invalidateQueries({ queryKey: [...queryKeys.strapi, 'workOrderDetail', jwt] });
    },
  });
}
